
import React from 'react';

interface CSOLoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const CSOLoadingSpinner: React.FC<CSOLoadingSpinnerProps> = ({ 
  size = 'md', 
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8', 
    lg: 'h-12 w-12'
  };

  return (
    <div className={`inline-flex items-center justify-center ${className}`}>
      <div className={`${sizeClasses[size]} relative`}>
        {/* CSO Agent logo-inspired spinner */}
        <div className="absolute inset-0 rounded-full border-4 border-cso-200"></div>
        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-cso-600 animate-spin"></div>
        <div className="absolute inset-2 rounded-full bg-gradient-to-br from-cso-500 to-cso-700 flex items-center justify-center">
          <span className="text-white font-bold text-xs">CSO</span>
        </div>
      </div>
    </div>
  );
};
